import { useState, useEffect } from "react";
import { useLogin } from "../hooks/useLogin";
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import '../style/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error, isLoading } = useLogin();
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  useEffect(() => {
    const lang = searchParams.get('lang');
    if (lang) {
      i18n.changeLanguage(lang);
      setSelectedLanguage(lang);
    }
  }, [searchParams]);

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (token) {
    // Decode JWT to get user info
    let name = '';
    let email = '';
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      name = payload.name || '';
      email = payload.email || '';
    } catch (e) {
      // fallback: leave name/email empty
    }
    const user = { token, name, email };
    localStorage.setItem('user', JSON.stringify(user));
    dispatch({ type: 'LOGIN', payload: user });
    navigate('/');
  }
}, [dispatch, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = await login(email, password);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
      dispatch({ type: 'LOGIN', payload: user });
      navigate('/');
    }
  };

  const handleGoogleLogin = () => {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    window.location.href = `${baseUrl}/api/users/google`;
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang);
  };

  return (
    <div className="login-container bg-dafauna-background rounded-xl shadow-md p-8">


      <form onSubmit={handleSubmit} className="space-y-4">
        <h3 className="text-dafauna-darkText text-2xl font-bold text-center">{t('login.title')}</h3>

        <label className="block text-dafauna-darkText font-medium">{t('login.emailLabel')}</label>
        <input
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          placeholder={t('login.emailPlaceholder')}
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
        />

        <label className="block text-dafauna-darkText font-medium">{t('login.passwordLabel')}</label>
        <input
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          placeholder={t('login.passwordPlaceholder')}
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
        />

        <button
          disabled={isLoading}
          className="w-full bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          {t('login.loginButton')}
        </button>
        <button
          type="button"
          onClick={handleGoogleLogin}
          className="google-login-button w-full bg-red-500 text-white rounded-md px-4 py-2 hover:bg-red-600"
        >
          {t('login.googleLoginButton')}
        </button>
        {error && <div className="error text-red-500 text-sm text-center mt-2">{t('login.error')}: {error}</div>}

        <div className="signup-redirect text-center text-dafauna-darkText">
          <p>
            {t('login.signupPrompt')} <Link to="/signup" className="text-dafauna-primary hover:underline">{t('login.signupLink')}</Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Login;